import * as React from 'react'
function SvgMobile(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M28 4H12a4 4 0 00-4 4v24a4 4 0 004 4h16a4 4 0 004-4V8a4 4 0 00-4-4zM12 30V10h16v20H12z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgMobile
